import { render, staticRenderFns } from "./rightSideBar.vue?vue&type=template&id=b5564388&scoped=true"
import script from "./rightSideBar.vue?vue&type=script&lang=js"
export * from "./rightSideBar.vue?vue&type=script&lang=js"
import style0 from "./rightSideBar.vue?vue&type=style&index=0&id=b5564388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5564388",
  null
  
)

export default component.exports